(function () {
  'use strict';

  // FREE GIFT ENGINE v13.0
  // ─────────────────────────────────────────────────────────────────────────────
  // BOGO REDESIGN — matches the "100% off" line item structure used by
  // professional gift apps (as seen in competitor screenshot):
  //
  //   OLD (abusable):
  //     Line 1: MANNOL 7832 1L (paid)   ₹909
  //     Line 2: MANNOL 7832 1L (₹1 gift variant) ← customer edits qty here
  //
  //   NEW (abuse-proof):
  //     Line 1: MANNOL 7832 1L (paid)   ₹909
  //     Line 2: MANNOL 7832 1L          FREE  ← SAME variant, properties mark it
  //                                           as free gift + 100% off applied via
  //                                           FREEGIFT_AUTO discount code
  //
  // HOW IT WORKS:
  //   - The free gift is added as the SAME triggerVariantId (not a separate ₹1 SKU)
  //   - Line item properties: { '_isFreeGift': 'true', 'Free Gift': 'Yes' }
  //   - The FREEGIFT_AUTO discount code zeroes it out (same as other gifts)
  //   - Shopify merges same-variant items by default, so we use a unique property
  //     trick to keep them as separate line items
  //   - Qty is always locked to 1 free unit regardless of paid qty
  //   - Before checkout: we verify the free line exists and has qty=1, fix if not
  //   - Nothing to abuse on Shiprocket because the free item price = ₹0 after
  //     discount, same as the competitor app structure
  //
  // NOTE: The old ₹1 gift variant IDs (44377600688221, 44377601867869) are
  // NO LONGER used and should be hidden/archived in Shopify admin.
  // ─────────────────────────────────────────────────────────────────────────────

  try {

  // ─── CONFIG ───────────────────────────────────────────────────────────────────

  var GLOBAL_DISCOUNT_CODE = 'FREEGIFT_AUTO';

  // BOGO config — gift is the SAME variant as trigger, qty always = 1
  // The free line item is identified by its '_isFreeGift' property
  // var BOGO_OFFERS_CONFIG = [
  //   {
  //     id:               'b1g1Powerbike',
  //     triggerVariantId: 44213801812061,  // MANNOL 7832 Powerbike 15W-50 1L (paid)
  //     sessionKey:       'b1g1PowerbikeShown',
  //     accentColor:      '#22c55e',
  //     heading:          'Buy 1 Get 1 Free!',
  //     subheading:       'Buy 1L of MANNOL 7832 Powerbike and get another 1L absolutely free!',
  //     label:            'MANNOL 7832 Powerbike 15W-50 - 1L (Free)',
  //     image:            'https://cdn.shopify.com/s/files/1/0687/5332/6173/files/61YpBWeBPrL._SL1200.webp?v=1768816343'
  //   },
  //   {
  //     id:               'b1g1Motorbike',
  //     triggerVariantId: 44213480161373,  // MANNOL 7814 Motorbike 10W-50 1L (paid)
  //     sessionKey:       'b1g1MotorbikeShown',
  //     accentColor:      '#22c55e',
  //     heading:          'Buy 1 Get 1 Free!',
  //     subheading:       'Buy 1L of MANNOL 7814 Motorbike and get another 1L absolutely free!',
  //     label:            'MANNOL 7814 Motorbike 10W-50 - 1L (Free)',
  //     image:            'https://cdn.shopify.com/s/files/1/0687/5332/6173/files/1_2f3d56c8-1d35-4bdc-8179-2b37378b23b0.webp?v=1768802948'
  //   }
  // ];

  var OFFERS = [
    {
      id: 'carOil5L',
      collectionHandle: 'cars-engine-oil',
      minLitres: 5,
      sessionKey: 'freeGiftShown_carOil5L',
      cacheKey: 'engineOilProductIds',
      accentColor: '#e8a020',
      discountCode: '',
      heading: "You've unlocked a Free Gift!",
      subheading: 'Choose one free additive - you must select one to continue:',
      excludeVariantIds: [43927436361821],
      gifts: [
        {
          variantId: 43393327104093,
          label: 'MANNOL Ceramo Ester 9829 - 350ml',
          image: 'https://cdn.shopify.com/s/files/1/0687/5332/6173/files/mannol9829-350ml.webp?v=1769167563'
        },
        {
          variantId: 44221420929117,
          label: 'MANNOL 9991 Molibden Additive - 350ml',
          image: 'https://cdn.shopify.com/s/files/1/0687/5332/6173/files/generated-image_1.webp?v=1768803956'
        }
      ]
    },
    {
      id: 'b1g1Mannol7722',
      isBogo: true,
      triggerVariantId: 43927436361821,
      sessionKey: 'b1g1Mannol7722Shown',
      accentColor: '#22c55e',
      discountCode: '',
      heading: 'Buy 1 Get 1 Free!',
      subheading: 'Buy 1x MANNOL 7722 Longlife 0W-20 5L and get 1L absolutely free!',
      gifts: [
        {
          variantId: 43927436329053,
          label: 'MANNOL 7722 Longlife 508/509 0W-20 - 1L (Free)',
          image: 'https://cdn.shopify.com/s/files/1/0687/5332/6173/files/MANNOL_7722_5L_LONGLIFE.webp?v=1768653095'
        }
      ]
    },
    {
      id: 'carOil4L',
      collectionHandle: 'cars-engine-oil',
      minLitres: 4,
      sessionKey: 'freeGiftShown_carOil4L',
      cacheKey: 'engineOilProductIds',
      accentColor: '#e8a020',
      discountCode: '',
      heading: "You've unlocked a Free Gift!",
      subheading: 'Choose one free additive - you must select one to continue:',
      gifts: [
        {
          variantId: 44221457596509,
          label: 'MANNOL 9900 Motor Flush - 350ml',
          image: 'https://cdn.shopify.com/s/files/1/0687/5332/6173/files/9900.webp?v=1768198476'
        },
        {
          variantId: 43543482368093,
          label: 'MANNOL 9930 Diesel Ester Additive - 250ml',
          image: 'https://cdn.shopify.com/s/files/1/0687/5332/6173/files/MN9930_250_F24_1.webp?v=1768816703'
        }
      ]
    },
    {
      id: 'coolant5L',
      collectionHandle: 'coolants-for-bikes-cars-trucks',
      minLitres: 5,
      sessionKey: 'freeGiftShown_coolant5L',
      cacheKey: 'coolantProductIds',
      accentColor: '#3b82f6',
      discountCode: '',
      heading: "You've unlocked a Free Gift!",
      subheading: 'Claim your free gift below:',
      gifts: [
        {
          variantId: 43393325826141,
          label: 'MANNOL 9965 Radiator Flush - 250ml',
          image: 'https://cdn.shopify.com/s/files/1/0687/5332/6173/files/MANNOL_9965_Radiator_Flush_Universal_COOLANT_System_Cleaner_-1.webp?v=1768819837'
        }
      ]
    },
    {
      id: 'bikeOil2L',
      collectionHandle: 'bikes-engine-oil',
      minLitres: 2,
      sessionKey: 'freeGiftShown_bikeOil2L',
      cacheKey: 'bikeOilProductIds',
      accentColor: '#a855f7',
      discountCode: '',
      heading: "You've unlocked a Free Gift!",
      subheading: 'Claim your free gift below:',
      // Exclude BOGO trigger variants so they don't count toward bikeOil2L threshold
      excludeVariantIds: [44213801812061, 44213480161373, 43927436361821, 43927436329053],
      gifts: [
        {
          variantId: 44220049948765,
          label: 'MANNOL 8121 White Grease Spray - 450ml',
          image: 'https://cdn.shopify.com/s/files/1/0687/5332/6173/files/511WIaIy6JL._SL1200.webp?v=1768825122'
        }
      ]
    }
  ];

  // ─── DERIVED ──────────────────────────────────────────────────────────────────

  var ALL_GIFT_VARIANT_IDS = [];
  for (var _i = 0; _i < OFFERS.length; _i++) {
    for (var _j = 0; _j < OFFERS[_i].gifts.length; _j++) {
      ALL_GIFT_VARIANT_IDS.push(OFFERS[_i].gifts[_j].variantId);
    }
  }

  // For BOGO: the gift variant IS the trigger variant, identified by property
  // We need to know trigger IDs to exclude them from litre counting
  var BOGO_TRIGGER_IDS = BOGO_OFFERS_CONFIG.map(function(o){ return o.triggerVariantId; });

  var LEGACY_BOGO_OFFERS = OFFERS.filter(function (o) { return o.isBogo; });

  // ─── STATE ────────────────────────────────────────────────────────────────────

  var _collectionCache  = {};
  var _internalCartOp   = false;
  var _checkInProgress  = false;
  var _debounceTimer    = null;
  var _initPurgeDone    = false;
  var _lastGhostJson    = '';
  var _mutationPaused   = false;
  var _discountApplied  = false;
  var _checkoutLocked   = false;

  // ─── SESSION ──────────────────────────────────────────────────────────────────

  function sGet(k)    { try { return sessionStorage.getItem(k); }    catch(e) { return null; } }
  function sSet(k, v) { try { sessionStorage.setItem(k, v); }        catch(e) {} }
  function sDel(k)    { try { sessionStorage.removeItem(k); }        catch(e) {} }

  // ─── GHOST GIFT STORE ─────────────────────────────────────────────────────────

  var GHOST_KEY = 'ug_ghost_gifts';

  function getGhosts() {
    try { var r = sessionStorage.getItem(GHOST_KEY); return r ? JSON.parse(r) : []; }
    catch(e) { return []; }
  }

  function setGhosts(arr) {
    try { sessionStorage.setItem(GHOST_KEY, JSON.stringify(arr)); } catch(e) {}
  }

  function addGhost(offerId, variantId, label, image) {
    var arr = getGhosts().filter(function(g){ return g.offerId !== offerId; });
    arr.push({ offerId: offerId, variantId: variantId, label: label, image: image });
    setGhosts(arr);
  }

  function removeGhost(offerId) {
    setGhosts(getGhosts().filter(function(g){ return g.offerId !== offerId; }));
  }

  function getGhost(offerId) {
    return getGhosts().filter(function(g){ return g.offerId === offerId; })[0] || null;
  }

  // ─── CART NOTE SYNC ───────────────────────────────────────────────────────────

  function syncCartNote() {
    var ghosts = getGhosts();
    var json   = JSON.stringify(ghosts);
    if (json === _lastGhostJson) { return; }
    _lastGhostJson = json;
    var note = ghosts.length
      ? ghosts.map(function(g){ return 'FREE GIFT: ' + g.label; }).join(' | ')
      : '';
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note })
    }).catch(function(){});
  }

  // ─── DISCOUNT CODE ────────────────────────────────────────────────────────────

  function applyDiscountCode(code) {
    if (!code || _discountApplied) { return Promise.resolve(); }
    _discountApplied = true;
    return fetch('/discount/' + encodeURIComponent(code), {
      method: 'GET',
      credentials: 'same-origin'
    }).catch(function(e) {
      console.warn('[UG] Discount apply failed:', e);
      _discountApplied = false;
    });
  }

  // ─── UTILS ────────────────────────────────────────────────────────────────────

  function toNum(raw) {
    if (typeof raw === 'number') { return raw; }
    var m = String(raw).match(/(\d+)$/);
    return m ? Number(m[1]) : NaN;
  }

  function parseLitres(val) {
    if (!val) { return 0; }
    var s = String(val).trim();
    var ml = s.match(/^(\d+(?:\.\d+)?)\s*ml$/i);
    if (ml) { return parseFloat(ml[1]) / 1000; }
    var l  = s.match(/^(\d+(?:\.\d+)?)\s*(?:l|ltr|ltrs|litre|litres?)$/i);
    if (l)  { return parseFloat(l[1]); }
    return 0;
  }

  function parseCans(val) {
    if (!val) { return 1; }
    var m = String(val).trim().match(/^(\d+)\s*(?:can|bottle|tin)s?$/i);
    return m ? parseInt(m[1], 10) : 1;
  }

  function calcItemLitres(item) {
    var size = '', numItems = '';
    if (item.options_with_values) {
      item.options_with_values.forEach(function(o) {
        var n = String(o.name||'').toLowerCase().trim();
        if (n === 'size')            { size     = o.value || ''; }
        if (n === 'number of items') { numItems = o.value || ''; }
      });
    }
    if (!size && item.variant_title && item.variant_title.toLowerCase().indexOf('default') === -1) {
      var pts = item.variant_title.split('/');
      size = (pts[0]||'').trim();
      if (pts[1]) { numItems = pts[1].trim(); }
    }
    if (!size && item.title) {
      var tm = item.title.match(/(\d+(?:\.\d+)?)\s*(?:l|ltr|litre|litres?|ml)/i);
      if (tm) { size = tm[0]; }
    }
    return parseLitres(size) * parseCans(numItems) * item.quantity;
  }

  function isGiftVid(vid) {
    var id = toNum(vid);
    for (var i = 0; i < ALL_GIFT_VARIANT_IDS.length; i++) {
      if (ALL_GIFT_VARIANT_IDS[i] === id) { return true; }
    }
    return false;
  }

  // Check if a cart line item is a BOGO free gift line
  // (same variant as paid, but has _isFreeGift property)
  function isBogoFreeGiftLine(item) {
    if (!item.properties) { return false; }
    var props = item.properties;
    // Properties can be array [{name,value}] or object {key:val}
    if (Array.isArray(props)) {
      return props.some(function(p) {
        return p.name === '_isFreeGift' && p.value === 'true';
      });
    }
    return props['_isFreeGift'] === 'true';
  }

  function invalidateCaches() {
    OFFERS.forEach(function(o) {
      if (!o.isBogo && o.cacheKey) {
        delete _collectionCache[o.cacheKey];
        sDel(o.cacheKey);
      }
    });
  }

  // ─── COLLECTION FETCH ─────────────────────────────────────────────────────────

  function fetchCollectionIds(handle, cacheKey) {
    if (_collectionCache[cacheKey] && _collectionCache[cacheKey].length) {
      return Promise.resolve(_collectionCache[cacheKey]);
    }
    try {
      var stored = JSON.parse(sessionStorage.getItem(cacheKey));
      if (stored && stored.length) { _collectionCache[cacheKey] = stored; return Promise.resolve(stored); }
    } catch(e) {}
    return fetch('/collections/' + handle + '/products.json?limit=250')
      .then(function(r){ return r.json(); })
      .then(function(d){
        var ids = d && d.products ? d.products.map(function(p){ return p.id; }) : [];
        _collectionCache[cacheKey] = ids;
        sSet(cacheKey, JSON.stringify(ids));
        return ids;
      })
      .catch(function(){ return []; });
  }

  // ─── CART HELPERS ─────────────────────────────────────────────────────────────

  function cartPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(r){ return r.json(); });
  }

  function fetchCart() {
    return fetch('/cart.js').then(function(r){ return r.json(); });
  }

  function dispatchCartEvents() {
    ['cart:updated','cart:refresh','theme:cart:updated'].forEach(function(evt) {
      try { document.dispatchEvent(new CustomEvent(evt)); } catch(e) {}
      try { window.dispatchEvent(new CustomEvent(evt)); }   catch(e) {}
    });
  }

  function removeGiftFromRealCart(variantId) {
    return fetchCart().then(function(cart) {
      var updates = {};
      var found   = false;
      (cart.items || []).forEach(function(item) {
        if (toNum(item.variant_id) === toNum(variantId)) {
          updates[item.key] = 0;
          found = true;
        }
      });
      if (!found) { return Promise.resolve(); }
      _internalCartOp = true;
      return cartPost('/cart/update.js', { updates: updates })
        .then(function() { _internalCartOp = false; })
        .catch(function() { _internalCartOp = false; });
    });
  }

  function initPurgeIfNeeded(items) {
    if (_initPurgeDone) { return Promise.resolve(); }
    _initPurgeDone = true;
    return Promise.resolve();
  }

  // ─── BOGO FREE GIFT LINE MANAGEMENT ──────────────────────────────────────────
  //
  // Finds the BOGO free-gift line item for a given triggerVariantId.
  // The free line is SAME variant ID as the paid line but has _isFreeGift=true.
  //
  // Shopify normally merges identical variants into one line item.
  // To prevent merging, we add a unique hidden property timestamp on first add.
  // On subsequent checks we find it by _isFreeGift property.

  function findBogoFreeLineInCart(triggerVariantId, items) {
    var vid = toNum(triggerVariantId);
    var freeLines = [];
    items.forEach(function(item) {
      if (toNum(item.variant_id) === vid && isBogoFreeGiftLine(item)) {
        freeLines.push(item);
      }
    });
    return freeLines; // may be multiple if something went wrong — we fix below
  }

  function findBogoPaidLineInCart(triggerVariantId, items) {
    var vid = toNum(triggerVariantId);
    var paid = null;
    items.forEach(function(item) {
      if (toNum(item.variant_id) === vid && !isBogoFreeGiftLine(item)) {
        paid = item;
      }
    });
    return paid;
  }

  // Add exactly 1 free gift line for this BOGO offer
  // Uses a timestamp property to prevent Shopify from merging with the paid line
  function addBogoFreeLine(offer) {
    _internalCartOp = true;
    return cartPost('/cart/add.js', {
      items: [{
        id: offer.triggerVariantId,
        quantity: 1,
        properties: {
          '_isFreeGift':   'true',
          '_bogoOffer':    offer.id,
          '_bogoTs':       String(Date.now()), // unique key prevents Shopify merge
          'Free Gift':     'Yes'               // visible label in Shopify admin
        }
      }]
    })
    .then(function(result) {
      _internalCartOp = false;
      return result;
    })
    .catch(function(err) {
      _internalCartOp = false;
      throw err;
    });
  }

  // Remove all free gift lines for a trigger variant (cleanup)
  function removeBogoFreeLines(triggerVariantId, items) {
    var freeLines = findBogoFreeLineInCart(triggerVariantId, items);
    if (!freeLines.length) { return Promise.resolve(); }
    var updates = {};
    freeLines.forEach(function(line) { updates[line.key] = 0; });
    _internalCartOp = true;
    return cartPost('/cart/update.js', { updates: updates })
      .then(function() { _internalCartOp = false; })
      .catch(function() { _internalCartOp = false; });
  }

  // Self-heal: ensure exactly 1 free line exists (remove extras, add if missing)
  function healBogoFreeLines(offer, items) {
    var freeLines = findBogoFreeLineInCart(offer.triggerVariantId, items);

    if (freeLines.length === 1) {
      // Perfect — ensure qty is 1
      if (freeLines[0].quantity === 1) { return Promise.resolve(); }
      var fix = {};
      fix[freeLines[0].key] = 1;
      _internalCartOp = true;
      return cartPost('/cart/update.js', { updates: fix })
        .then(function() { _internalCartOp = false; })
        .catch(function() { _internalCartOp = false; });
    }

    if (freeLines.length > 1) {
      // Multiple free lines — remove all extras, keep first
      var extras = {};
      for (var i = 1; i < freeLines.length; i++) {
        extras[freeLines[i].key] = 0;
      }
      // Also ensure first is qty 1
      if (freeLines[0].quantity !== 1) { extras[freeLines[0].key] = 1; }
      _internalCartOp = true;
      return cartPost('/cart/update.js', { updates: extras })
        .then(function() { _internalCartOp = false; })
        .catch(function() { _internalCartOp = false; });
    }

    // No free line — add one
    return addBogoFreeLine(offer);
  }

  // ─── NEW BOGO CHECKOUT GUARD ──────────────────────────────────────────────────
  // Before checkout: verify each BOGO offer's free line has qty=1 and
  // the paid trigger line exists. Fix any discrepancy silently.

  function validateBogoBeforeCheckout() {
    return fetchCart().then(function(cart) {
      var items   = cart.items || [];
      var updates = {};
      var needsFix = false;

      BOGO_OFFERS_CONFIG.forEach(function(offer) {
        var paidLine  = findBogoPaidLineInCart(offer.triggerVariantId, items);
        var freeLines = findBogoFreeLineInCart(offer.triggerVariantId, items);

        if (!freeLines.length) { return; } // No free gift in cart — nothing to guard

        if (!paidLine) {
          // Abuse: free gift line exists but paid item gone — remove all free lines
          freeLines.forEach(function(line) { updates[line.key] = 0; });
          needsFix = true;
          console.warn('[UG GUARD] Removed orphan BOGO free lines for:', offer.id);
          return;
        }

        // Remove any duplicate free lines (keep first, zero rest)
        if (freeLines.length > 1) {
          for (var i = 1; i < freeLines.length; i++) {
            updates[freeLines[i].key] = 0;
          }
          needsFix = true;
        }

        // Ensure remaining free line qty = 1
        if (freeLines[0] && freeLines[0].quantity !== 1) {
          updates[freeLines[0].key] = 1;
          needsFix = true;
          console.warn('[UG GUARD] Clamped BOGO free line qty to 1 for:', offer.id);
        }
      });

      if (!needsFix) { return Promise.resolve(); }

      _internalCartOp = true;
      return cartPost('/cart/update.js', { updates: updates })
        .then(function() { _internalCartOp = false; })
        .catch(function() { _internalCartOp = false; });
    });
  }

  // ─── POPUP ────────────────────────────────────────────────────────────────────

  function injectStyles() {
    if (document.getElementById('ug-styles')) { return; }
    var css =
      '.ug-overlay{display:none;position:fixed;top:0;left:0;right:0;bottom:0;z-index:2147483640;background:rgba(0,0,0,0.85);align-items:center;justify-content:center;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif}' +
      '.ug-overlay.ug-active{display:flex}' +
      '.ug-modal{background:#111418;border-radius:16px;padding:32px 28px;max-width:540px;width:92%;box-shadow:0 24px 64px rgba(0,0,0,.7);animation:ugIn .28s ease}' +
      '@keyframes ugIn{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}' +
      '.ug-heading{font-size:1.35rem;font-weight:700;color:#fff;margin:0 0 6px;text-align:center}' +
      '.ug-subheading{font-size:.9rem;color:#9ca3af;margin:0 0 20px;text-align:center}' +
      '.ug-cards{display:flex;flex-wrap:wrap;gap:14px;justify-content:center}' +
      '.ug-card{background:#1a1d23;border-radius:12px;padding:16px;display:flex;flex-direction:column;align-items:center;width:148px;text-align:center}' +
      '.ug-card img{width:140px;height:140px;object-fit:contain;border-radius:8px;margin-bottom:10px}' +
      '.ug-badge{display:inline-block;background:#22c55e;color:#fff;font-size:.7rem;font-weight:700;padding:2px 8px;border-radius:99px;margin-bottom:8px}' +
      '.ug-label{font-size:.8rem;color:#d1d5db;margin-bottom:12px;line-height:1.3}' +
      '.ug-btn{width:100%;padding:9px 0;border:none;border-radius:8px;font-size:.85rem;font-weight:600;cursor:pointer;color:#fff;transition:opacity .15s}' +
      '.ug-btn:disabled{background:#2a2d35!important;cursor:not-allowed;opacity:.7}' +
      '.ug-btn:not(:disabled):hover{opacity:.85}' +
      '.ug-warn{display:none;color:#f87171;font-size:.8rem;margin-top:14px;text-align:center}' +
      '.ug-note{color:#6b7280;font-size:.75rem;margin-top:12px;text-align:center}' +
      '.ug-ghost-row{display:flex;align-items:center;gap:12px;padding:12px 0;border-top:1px solid rgba(128,128,128,.2)}' +
      '.ug-ghost-img{width:60px;height:60px;object-fit:contain;border-radius:6px;flex-shrink:0}' +
      '.ug-ghost-info{flex:1}' +
      '.ug-ghost-name{font-size:.82rem;line-height:1.3;margin-bottom:4px}' +
      '.ug-ghost-free{color:#22c55e;font-weight:700;font-size:.82rem}' +
      '.ug-ghost-badge{display:inline-block;background:#22c55e;color:#fff;font-size:.65rem;font-weight:700;padding:1px 6px;border-radius:99px;margin-left:6px}' +
      '@media(max-width:420px){.ug-card{width:100%}.ug-card img{width:100%;height:auto}}';
    var s = document.createElement('style');
    s.id = 'ug-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function buildBogoPopup(offer) {
    var pid = 'ug-popup-' + offer.id;
    if (document.getElementById(pid) || !document.body) { return; }

    var overlay = document.createElement('div');
    overlay.id        = pid;
    overlay.className = 'ug-overlay';

    var modal = document.createElement('div');
    modal.className = 'ug-modal';

    var h = document.createElement('p');
    h.className = 'ug-heading'; h.textContent = offer.heading;
    modal.appendChild(h);

    var sub = document.createElement('p');
    sub.className = 'ug-subheading'; sub.textContent = offer.subheading;
    modal.appendChild(sub);

    var cards = document.createElement('div');
    cards.className = 'ug-cards';

    var card = document.createElement('div');
    card.className = 'ug-card';

    var img = document.createElement('img');
    img.src = offer.image; img.alt = offer.label; img.loading = 'lazy';
    card.appendChild(img);

    var badge = document.createElement('span');
    badge.className = 'ug-badge'; badge.textContent = 'FREE';
    card.appendChild(badge);

    var lbl = document.createElement('p');
    lbl.className = 'ug-label'; lbl.textContent = offer.label;
    card.appendChild(lbl);

    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'ug-btn';
    btn.textContent = 'Claim Free Gift';
    btn.style.background = offer.accentColor;
    btn.addEventListener('click', function() { claimBogoGift(offer, btn); });
    card.appendChild(btn);
    cards.appendChild(card);
    modal.appendChild(cards);

    var note = document.createElement('p');
    note.className = 'ug-note';
    note.textContent = 'This free gift will be packed with your order.';
    modal.appendChild(note);

    overlay.appendChild(modal);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        // Do nothing — force them to click Claim
      }
    });

    document.body.appendChild(overlay);
  }

  function buildPopup(offer) {
    var pid = 'ug-popup-' + offer.id;
    if (document.getElementById(pid) || !document.body) { return; }

    var overlay = document.createElement('div');
    overlay.id        = pid;
    overlay.className = 'ug-overlay';

    var modal = document.createElement('div');
    modal.className = 'ug-modal';

    var h = document.createElement('p');
    h.className = 'ug-heading'; h.textContent = offer.heading;
    modal.appendChild(h);

    var s = document.createElement('p');
    s.className = 'ug-subheading'; s.textContent = offer.subheading;
    modal.appendChild(s);

    var cards = document.createElement('div');
    cards.className = 'ug-cards';

    offer.gifts.forEach(function(gift) {
      var card = document.createElement('div');
      card.className = 'ug-card';

      var img = document.createElement('img');
      img.src = gift.image; img.alt = gift.label; img.loading = 'lazy';
      card.appendChild(img);

      var badge = document.createElement('span');
      badge.className = 'ug-badge'; badge.textContent = 'FREE';
      card.appendChild(badge);

      var lbl = document.createElement('p');
      lbl.className = 'ug-label'; lbl.textContent = gift.label;
      card.appendChild(lbl);

      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'ug-btn';
      btn.textContent = 'Claim Free Gift';
      btn.style.background = offer.accentColor;
      btn.addEventListener('click', function() { claimGhostGift(offer, gift, btn); });
      card.appendChild(btn);
      cards.appendChild(card);
    });

    modal.appendChild(cards);

    var warn = document.createElement('p');
    warn.id = 'ug-warn-' + offer.id; warn.className = 'ug-warn';
    warn.textContent = offer.gifts.length > 1
      ? 'You must select one gift to continue'
      : 'You must claim your gift to continue';
    modal.appendChild(warn);

    if (offer.gifts.length === 1) {
      var note = document.createElement('p');
      note.className = 'ug-note';
      note.textContent = 'This free gift will be packed with your order.';
      modal.appendChild(note);
    }

    overlay.appendChild(modal);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        var w = document.getElementById('ug-warn-' + offer.id);
        if (w) { w.style.display = 'block'; }
      }
    });

    document.body.appendChild(overlay);
  }

  function showPopup(offerId) {
    if (!document.body) {
      document.addEventListener('DOMContentLoaded', function() { showPopup(offerId); });
      return;
    }
    var el = document.getElementById('ug-popup-' + offerId);
    if (el) { el.classList.add('ug-active'); }
  }

  function hidePopup(offerId) {
    var el = document.getElementById('ug-popup-' + offerId);
    if (el) { el.classList.remove('ug-active'); }
  }

  // ─── CLAIM BOGO GIFT (new approach) ──────────────────────────────────────────

  function claimBogoGift(offer, btn) {
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

    // Record in session
    sSet(offer.sessionKey, JSON.stringify({ gifted: true }));
    sSet(offer.sessionKey + '_shown', 'true');

    // Add ghost for cart drawer display
    addGhost(offer.id, offer.triggerVariantId, offer.label, offer.image);

    // Add the free line to cart (same variant, _isFreeGift=true property)
    addBogoFreeLine(offer)
      .then(function() {
        return applyDiscountCode(GLOBAL_DISCOUNT_CODE);
      })
      .then(function() {
        syncCartNote();
        hidePopup(offer.id);
        renderGhostRows();
        dispatchCartEvents();
      })
      .catch(function(err) {
        console.error('[UG] Failed to add BOGO free line:', err);
        syncCartNote();
        hidePopup(offer.id);
        renderGhostRows();
        dispatchCartEvents();
      });
  }

  // ─── CLAIM REGULAR GIFT ───────────────────────────────────────────────────────

  function claimGhostGift(offer, gift, btn) {
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

    addGhost(offer.id, gift.variantId, gift.label, gift.image);

    if (offer.isBogo) {
      var raw = sGet(offer.sessionKey);
      var paidQty = 1;
      try { var sd = raw ? JSON.parse(raw) : null; if (sd && sd.paidQty) { paidQty = sd.paidQty; } } catch(e) {}
      sSet(offer.sessionKey, JSON.stringify({ gifted: true, paidQty: paidQty }));
      sSet(offer.sessionKey + '_shown', 'true');
    } else {
      sSet(offer.sessionKey, 'true');
    }

    _internalCartOp = true;
    cartPost('/cart/add.js', {
      items: [{
        id: gift.variantId,
        quantity: 1,
        properties: {
          '_isFreeGift': 'true',
          'Free Gift': 'Yes'
        }
      }]
    })
    .then(function() {
      _internalCartOp = false;
      var code = offer.discountCode || GLOBAL_DISCOUNT_CODE;
      return applyDiscountCode(code);
    })
    .then(function() {
      syncCartNote();
      hidePopup(offer.id);
      renderGhostRows();
      dispatchCartEvents();
    })
    .catch(function(err) {
      console.error('[UG] Failed to add gift:', err);
      _internalCartOp = false;
      syncCartNote();
      hidePopup(offer.id);
      renderGhostRows();
      dispatchCartEvents();
    });
  }

  // ─── GHOST ROW RENDERING ──────────────────────────────────────────────────────

  var GHOST_ROW_ATTR = 'data-ug-ghost';

  var CART_CONTAINER_SELECTORS = [
    '.cart-drawer__items', '.cart-items', '.cart__items',
    '[data-cart-items]', '.cart-drawer__body ul', '.cart-drawer__body',
    '#cart-items', '.cart__body', '.cart-item-list',
    'ul.cart__line-items', '.cart-lines'
  ];

  function findCartContainer() {
    for (var i = 0; i < CART_CONTAINER_SELECTORS.length; i++) {
      var el = document.querySelector(CART_CONTAINER_SELECTORS[i]);
      if (el) { return el; }
    }
    return null;
  }

  function renderGhostRows() {
    var old = document.querySelectorAll('[' + GHOST_ROW_ATTR + ']');
    for (var i = 0; i < old.length; i++) {
      old[i].parentNode && old[i].parentNode.removeChild(old[i]);
    }
    var ghosts = getGhosts();
    if (!ghosts.length) { return; }
    var container = findCartContainer();
    if (!container) { return; }

    _mutationPaused = true;
    ghosts.forEach(function(ghost) {
      var row = document.createElement('div');
      row.setAttribute(GHOST_ROW_ATTR, ghost.offerId);
      row.className = 'ug-ghost-row';

      var img = document.createElement('img');
      img.src = ghost.image; img.alt = ghost.label;
      img.className = 'ug-ghost-img'; img.loading = 'lazy';
      row.appendChild(img);

      var info = document.createElement('div');
      info.className = 'ug-ghost-info';

      var name = document.createElement('div');
      name.className = 'ug-ghost-name'; name.textContent = ghost.label;
      info.appendChild(name);

      var pr = document.createElement('div');
      var freeSpan = document.createElement('span');
      freeSpan.className = 'ug-ghost-free'; freeSpan.textContent = 'Rs. 0.00';
      pr.appendChild(freeSpan);
      var badge = document.createElement('span');
      badge.className = 'ug-ghost-badge'; badge.textContent = 'FREE GIFT';
      pr.appendChild(badge);
      info.appendChild(pr);
      row.appendChild(info);
      container.appendChild(row);
    });

    setTimeout(function() { _mutationPaused = false; }, 100);
  }

  // ─── NEW BOGO CHECK LOGIC ─────────────────────────────────────────────────────

  function checkNewBogo(items) {
    BOGO_OFFERS_CONFIG.forEach(function(offer) {
      var paidLine = findBogoPaidLineInCart(offer.triggerVariantId, items);
      var paidQty  = paidLine ? paidLine.quantity : 0;

      var sd = null;
      try { var raw = sGet(offer.sessionKey); if (raw) { sd = JSON.parse(raw); } } catch(e) {}

      // ── Trigger removed from cart ─────────────────────────────────────────────
      if (paidQty === 0) {
        hidePopup(offer.id);
        sDel(offer.sessionKey);
        sDel(offer.sessionKey + '_shown');
        var ghost0 = getGhost(offer.id);
        if (ghost0) {
          removeGhost(offer.id);
          syncCartNote();
          renderGhostRows();
          // Remove free lines
          removeBogoFreeLines(offer.triggerVariantId, items)
            .then(function() { dispatchCartEvents(); });
        }
        return;
      }

      // ── Gift already claimed — self-heal ──────────────────────────────────────
      if (sd && sd.gifted === true) {
        var ghost1 = getGhost(offer.id);
        if (ghost1) {
          healBogoFreeLines(offer, items).then(function() { dispatchCartEvents(); });
          hidePopup(offer.id);
        } else {
          // Ghost was cleared (e.g. customer removed it) — reset to re-show popup
          sDel(offer.sessionKey);
          sDel(offer.sessionKey + '_shown');
          // Also remove any lingering free lines
          removeBogoFreeLines(offer.triggerVariantId, items);
        }
        return;
      }

      // ── Not yet shown — show popup once ──────────────────────────────────────
      if (sGet(offer.sessionKey + '_shown') !== 'true') {
        sSet(offer.sessionKey + '_shown', 'true');
        sSet(offer.sessionKey, JSON.stringify({ gifted: false }));
        buildBogoPopup(offer);
        showPopup(offer.id);
      }
    });
  }

  // ─── LEGACY BOGO (b1g1Mannol7722) ────────────────────────────────────────────

  function checkLegacyBogo(items) {
    LEGACY_BOGO_OFFERS.forEach(function(offer) {
      var trigId  = toNum(offer.triggerVariantId);
      var paidQty = 0;
      items.forEach(function(item) {
        if (isGiftVid(item.variant_id)) { return; }
        if (toNum(item.variant_id) === trigId) { paidQty += item.quantity; }
      });

      var sd = null;
      try { var raw = sGet(offer.sessionKey); if (raw) { sd = JSON.parse(raw); } } catch(e) {}

      if (paidQty === 0) {
        hidePopup(offer.id);
        sDel(offer.sessionKey);
        sDel(offer.sessionKey + '_shown');
        var ghost0 = getGhost(offer.id);
        if (ghost0) {
          var gv0 = ghost0.variantId;
          removeGhost(offer.id);
          syncCartNote();
          renderGhostRows();
          setGiftQtyInCart(gv0, 0, items).then(function() { dispatchCartEvents(); });
        }
        return;
      }

      if (sd && sd.gifted === true) {
        sSet(offer.sessionKey, JSON.stringify({ gifted: true, paidQty: paidQty }));
        var ghost1 = getGhost(offer.id);
        if (ghost1) {
          var currentGiftQty = 0;
          items.forEach(function(item) {
            if (toNum(item.variant_id) === toNum(ghost1.variantId)) { currentGiftQty += item.quantity; }
          });
          if (currentGiftQty !== 1) {
            setGiftQtyInCart(ghost1.variantId, 1, items).then(function() { dispatchCartEvents(); });
          }
          hidePopup(offer.id);
        } else {
          sDel(offer.sessionKey);
          sDel(offer.sessionKey + '_shown');
        }
        return;
      }

      if (sGet(offer.sessionKey + '_shown') !== 'true') {
        sSet(offer.sessionKey + '_shown', 'true');
        sSet(offer.sessionKey, JSON.stringify({ gifted: false, paidQty: paidQty }));
        buildPopup(offer);
        showPopup(offer.id);
      }
    });
  }

  function setGiftQtyInCart(giftVariantId, desiredQty, items) {
    var currentQty = 0;
    var itemKey    = null;
    (items || []).forEach(function(item) {
      if (toNum(item.variant_id) === toNum(giftVariantId)) {
        currentQty += item.quantity;
        itemKey = item.key;
      }
    });
    if (currentQty === desiredQty) { return Promise.resolve(); }
    _internalCartOp = true;
    if (desiredQty === 0) {
      var updates = {};
      if (itemKey) { updates[itemKey] = 0; }
      return cartPost('/cart/update.js', { updates: updates })
        .then(function() { _internalCartOp = false; })
        .catch(function() { _internalCartOp = false; });
    }
    var removeFirst = currentQty > 0
      ? (function() { var u = {}; if (itemKey) { u[itemKey] = 0; } return cartPost('/cart/update.js', { updates: u }); })()
      : Promise.resolve();
    return removeFirst
      .then(function() {
        return cartPost('/cart/add.js', {
          items: [{ id: giftVariantId, quantity: desiredQty, properties: { '_isFreeGift': 'true', 'Free Gift': 'Yes' } }]
        });
      })
      .then(function() { _internalCartOp = false; })
      .catch(function() { _internalCartOp = false; });
  }

  // ─── CHECKOUT BUTTON INTERCEPT ────────────────────────────────────────────────

  function interceptCheckoutButtons() {
    if (window._ugCheckoutPatched) { return; }
    window._ugCheckoutPatched = true;

    var BTN_SELECTORS = [
      '[name="checkout"]',
      'button[data-checkout-btn]',
      '.cart__checkout',
      '.cart-drawer__checkout',
      '.cart__cta a',
      '[data-testid="Checkout-button"]',
      '.shopify-payment-button__button',
      'input[type="submit"][name="checkout"]'
    ].join(',');

    var CHECKOUT_LINK_RE = /\/checkout|\/checkouts\//;

    function handleCheckoutAttempt(e, element) {
      if (_checkoutLocked) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      e.preventDefault();
      e.stopImmediatePropagation();
      _checkoutLocked = true;

      var origText = '', origVal = '';
      if (element) {
        if (element.tagName === 'INPUT') { origVal = element.value || ''; element.value = 'Preparing...'; element.disabled = true; }
        else if (element.tagName !== 'A') { origText = element.textContent || ''; element.textContent = 'Preparing...'; element.disabled = true; }
      }

      function restore() {
        if (!element) { return; }
        if (element.tagName === 'INPUT') { element.value = origVal; element.disabled = false; }
        else if (element.tagName !== 'A') { element.textContent = origText; element.disabled = false; }
      }

      function proceed() {
        _checkoutLocked = false;
        restore();
        window.location.href = (element && element.tagName === 'A' && element.href) ? element.href : '/checkout';
      }

      validateBogoBeforeCheckout()
        .then(proceed)
        .catch(function(err) { console.error('[UG] Checkout guard error:', err); proceed(); });
    }

    document.addEventListener('click', function(e) {
      var el = e.target;
      while (el && el !== document.documentElement) {
        if (el.matches) {
          if (el.matches(BTN_SELECTORS)) { handleCheckoutAttempt(e, el); return; }
          if (el.tagName === 'A' && el.href && CHECKOUT_LINK_RE.test(el.href)) { handleCheckoutAttempt(e, el); return; }
        }
        el = el.parentElement;
      }
    }, true);

    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (form && form.action && CHECKOUT_LINK_RE.test(form.action)) {
        if (_checkoutLocked) { e.preventDefault(); return; }
        e.preventDefault();
        _checkoutLocked = true;
        validateBogoBeforeCheckout()
          .then(function() { _checkoutLocked = false; form.submit(); })
          .catch(function() { _checkoutLocked = false; form.submit(); });
      }
    }, true);
  }

  // ─── MAIN CHECK ───────────────────────────────────────────────────────────────

  function checkAllOffers() {
    if (_internalCartOp || _checkInProgress) { return; }
    _checkInProgress = true;

    var cacheKeyMap = {};
    OFFERS.forEach(function(o) {
      if (!o.isBogo && o.cacheKey && !cacheKeyMap[o.cacheKey]) {
        cacheKeyMap[o.cacheKey] = o.collectionHandle;
      }
    });

    var fps = Object.keys(cacheKeyMap).map(function(k) {
      return fetchCollectionIds(cacheKeyMap[k], k);
    });

    Promise.all([Promise.all(fps), fetchCart()])
      .then(function(results) {
        var items = results[1].items || [];
        return initPurgeIfNeeded(items).then(function() { return items; });
      })
      .then(function(items) {
        // Run new BOGO check (Powerbike + Motorbike)
        checkNewBogo(items);
        // Run legacy BOGO check (7722)
        checkLegacyBogo(items);

        var carOilExcluded = [];
        OFFERS.forEach(function(o) {
          if ((o.id === 'carOil5L' || o.id === 'carOil4L') && o.excludeVariantIds) {
            carOilExcluded = carOilExcluded.concat(o.excludeVariantIds);
          }
        });

        var carOilIds    = _collectionCache['engineOilProductIds'] || [];
        var totalCarOilL = 0;
        items.forEach(function(item) {
          if (isGiftVid(item.variant_id)) { return; }
          // Exclude BOGO free gift lines from litre counting
          if (isBogoFreeGiftLine(item)) { return; }
          var excl = carOilExcluded.some(function(x){ return toNum(x) === toNum(item.variant_id); });
          if (!excl && carOilIds.indexOf(item.product_id) !== -1) {
            totalCarOilL += calcItemLitres(item);
          }
        });

        OFFERS.forEach(function(offer) {
          if (offer.isBogo) { return; }

          var collIds = _collectionCache[offer.cacheKey] || [];
          var totalL  = 0;

          if (offer.id === 'carOil5L' || offer.id === 'carOil4L') {
            totalL = totalCarOilL;
          } else {
            items.forEach(function(item) {
              if (isGiftVid(item.variant_id)) { return; }
              if (isBogoFreeGiftLine(item)) { return; }
              var excl = offer.excludeVariantIds &&
                offer.excludeVariantIds.some(function(x){ return toNum(x) === toNum(item.variant_id); });
              if (!excl && collIds.indexOf(item.product_id) !== -1) {
                totalL += calcItemLitres(item);
              }
            });
          }

          var meets = totalL >= offer.minLitres;

          if (offer.id === 'carOil4L' && totalCarOilL >= 5) {
            hidePopup(offer.id);
            if (getGhost(offer.id)) {
              var gvId = getGhost(offer.id).variantId;
              removeGhost(offer.id);
              syncCartNote();
              renderGhostRows();
              removeGiftFromRealCart(gvId).then(function() { dispatchCartEvents(); });
            }
            return;
          }

          if (!meets) {
            hidePopup(offer.id);
            if (getGhost(offer.id)) {
              var gvId = getGhost(offer.id).variantId;
              removeGhost(offer.id);
              sDel(offer.sessionKey);
              syncCartNote();
              renderGhostRows();
              removeGiftFromRealCart(gvId).then(function() { dispatchCartEvents(); });
            }
            sDel(offer.sessionKey);
            return;
          }

          if (getGhost(offer.id)) { hidePopup(offer.id); return; }
          if (!sGet(offer.sessionKey)) {
            buildPopup(offer);
            showPopup(offer.id);
          }
        });

        renderGhostRows();
        syncCartNote();
      })
      .catch(function(err) { console.error('[UG] checkAllOffers error:', err); })
      .then(function() { _checkInProgress = false; });
  }

  // ─── DEBOUNCED TRIGGER ────────────────────────────────────────────────────────

  var DEBOUNCE_MS = 500;

  function scheduleCheck() {
    if (_internalCartOp) { return; }
    clearTimeout(_debounceTimer);
    _debounceTimer = setTimeout(function() {
      invalidateCaches();
      checkAllOffers();
    }, DEBOUNCE_MS);
  }

  // ─── FETCH INTERCEPT ──────────────────────────────────────────────────────────

  var CART_RE = /\/cart\/(add|change|update|clear)/;

  function interceptFetch() {
    if (window._ugFetchPatched) { return; }
    window._ugFetchPatched = true;
    var orig = window.fetch;
    window.fetch = function(input, init) {
      var url = typeof input === 'string' ? input : (input && input.url ? input.url : '');
      var isCart = CART_RE.test(url);
      return orig.apply(this, arguments).then(function(response) {
        if (isCart && !_internalCartOp) { scheduleCheck(); }
        return response;
      });
    };
  }

  // ─── XHR INTERCEPT ───────────────────────────────────────────────────────────

  function interceptXHR() {
    if (window._ugXHRPatched) { return; }
    window._ugXHRPatched = true;
    var orig = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
      if (CART_RE.test(url)) {
        this.addEventListener('load', function() {
          if (!_internalCartOp) { scheduleCheck(); }
        });
      }
      return orig.apply(this, arguments);
    };
  }

  // ─── CART EVENT LISTENERS ─────────────────────────────────────────────────────

  function listenCartEvents() {
    var handler = function() { scheduleCheck(); };
    ['cart:updated','cart:refresh','theme:cart:updated'].forEach(function(evt) {
      document.addEventListener(evt, handler);
      window.addEventListener(evt, handler);
    });
  }

  // ─── MUTATION OBSERVER ────────────────────────────────────────────────────────

  function observeCartChanges() {
    if (!window.MutationObserver || !document.body) { return; }
    var observer = new MutationObserver(function(mutations) {
      if (_mutationPaused) { return; }
      var relevant = false;
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType === 1 && !node.hasAttribute(GHOST_ROW_ATTR)) { relevant = true; break; }
        }
        if (relevant) { break; }
      }
      if (relevant) { renderGhostRows(); }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // ─── INIT ─────────────────────────────────────────────────────────────────────

  function init() {
    injectStyles();
    interceptFetch();
    interceptXHR();
    listenCartEvents();

    function ready() {
      observeCartChanges();
      renderGhostRows();
      interceptCheckoutButtons();
      checkAllOffers();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', ready);
    } else {
      ready();
    }
  }

  init();

  } catch(fatalErr) {
    console.error('[UG] FATAL:', fatalErr);
  }

}());